export enum GAME_TYPE {
  Casino = 1,
  Fantasy = 2,
  Rummy = 3,
  Sports = 4,
}

export const GAME_TYPE_MAP = {
  [GAME_TYPE.Casino]: 'Casino',
  [GAME_TYPE.Fantasy]: 'Fantasy',
  [GAME_TYPE.Rummy]: 'Rummy',
  [GAME_TYPE.Sports]: 'Sports',
};

export const BannerAutoPlayProps = {
  playOnInit: true,
  delay: 6000,
  stopOnInteraction: false,
  stopOnMouseEnter: false
};